import { useState } from 'react'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import Organizacao from '../../middleware/Organizacao'
import Permissoes from '../../middleware/Permissoes'
import ModulosContratados from '../../middleware/SistemasContratados'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuDashboard(props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu() {
        setSubMenu(subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'suporte', 'consultor', 'desenvolvedor', 'dashboard_acesso']}>
            <div>
                <div id='menuOpcoes' onClick={exibirSubmenu}>
                    {<img id='iconeMenu' src={props.icone} alt={props.alt}></img>}
                    <p id='tituloMenu'>{props.titulo}</p>
                </div>
                <div id='submenuOpcoes'>
                    <Permissoes permissoes={['master', 'dashboard_geral']}>
                        {subMenu && <SubMenuOpcoes redirect='/dashboard' texto='Geral' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'dashboard_financeiro']}>
                        {subMenu && <SubMenuOpcoes redirect='/dashboard/financeiro' texto='Financeiro' />}
                    </Permissoes>
                        {subMenu && <ModulosContratados modulo={["Recrutamento"]}>
                            <Permissoes permissoes={['master', 'dashboard_processo_seletivo']}>
                                <SubMenuOpcoes redirect='/dashboard/processos-seletivos' texto='Processos Seletivos' />
                            </Permissoes>
                        </ModulosContratados>}
                        {subMenu && <ModulosContratados modulo={["Recrutamento"]}>
                            <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
                                <Permissoes permissoes={['master', 'dashboard_banco_talentos']}>
                                    <SubMenuOpcoes redirect='/dashboard/candidatos' texto='Banco de Talentos' />
                                </Permissoes>
                            </Organizacao>
                        </ModulosContratados>}
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'consultor', 'desenvolvedor', 'suporte', 'dashboard_meu_painel']}>
                        {subMenu && <SubMenuOpcoes redirect={'/painel'} texto='Meu Painel' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuDashboard